import { Stack, Text } from '@mantine/core';
import { useCalendars } from 'src/meetings/hooks/useCalendars';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import PageLoader from 'src/UI/loader/PageLoader';
import { ConnectedCalendarAccountCard } from 'src/meetings/components/ConnectedCalendarAccountCard';

type Props = {
  filter?: 'CONNECTED' | 'DISCONNECTED' | 'CONNECTING';
};

export const CalendarsListComponent = ({ filter = 'CONNECTED' }: Props) => {
  const {
    connectedCalendars,
    disconnectedCalendars,
    connectingCalendars,
    isLoading: isLoadingCalendar,
    refetch,
  } = useCalendars();
  const calendars = {
    CONNECTED: connectedCalendars,
    DISCONNECTED: disconnectedCalendars,
    CONNECTING: connectingCalendars,
  }[filter];

  const title = {
    CONNECTED: 'Connected calendars',
    DISCONNECTED: 'Disconnected calendars',
    CONNECTING: 'Connecting calendars',
  }[filter];

  if (calendars.length === 0 && !isLoadingCalendar) {
    return null;
  }

  return (
    <Stack gap="xs">
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {title}
      </Text>
      {isLoadingCalendar ? (
        <PageLoader absolute={false} />
      ) : (
        calendars.map(calendar => (
          <ConnectedCalendarAccountCard
            key={calendar.id}
            calendar={calendar}
            onDisconnected={refetch}
          />
        ))
      )}
    </Stack>
  );
};
